import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm, AvInput } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from 'reactstrap';

import { getDmxControllers, getDmxUniversesByController, getDmxProfiles, updateDmxDevice, deleteDmxDevice } from '../../store/actions';

class UpdateDmxDeviceForm extends Component {
  constructor(props) {
    super(props);
    const device = this.props.device;
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      device,
      // AA-11839: selects controlados por estado de React (no solo por la prop
      // `value` inicial de AvInput) para que precarguen de verdad el valor
      // actual del dispositivo al editar, en vez de mostrar siempre la primera
      // opción de la lista.
      deviceType: device.device_type,
      profileId: device.profile_id ?? '',
      linkedEntityType: device.linked_entity_type,
      linkedEntityId: device.linked_entity_id,
      controllerId: device.controller_id,
      universeId: device.universe_id,
      startChannel: device.start_channel,
      channelCount: device.channel_count,
      popup: false,
      pop_msg: '',
      alertType: '',
      showConfirmDelete: false,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getDmxControllers(this.state.user);
    this.props.getDmxUniversesByController(this.state.user, this.state.device.controller_id);
    this.props.getDmxProfiles(this.state.user);
  }

  onProfileChange(profileId) {
    const profile = (this.props.profiles || []).find((p) => String(p.id) === String(profileId));
    this.setState({ profileId, channelCount: profile ? profile.channel_count : this.state.channelCount });
  }

  componentDidUpdate(prevProps) {
    const { updateDmxDeviceError, loadingUpdateDmxDevice, messageDmxDevice: msgUpdate } = this.props;
    if (loadingUpdateDmxDevice === false && prevProps.loadingUpdateDmxDevice === true) {
      if (updateDmxDeviceError) {
        this.setState({
          popup: true,
          pop_msg: updateDmxDeviceError.message || 'Error al modificar el dispositivo',
          alertType: 'error',
        });
      } else if (msgUpdate) {
        this.setState({ popup: true, pop_msg: 'Dispositivo modificado correctamente', alertType: 'correct' });
      }
    }

    const { loadingDeleteDmxDevice, messageDmxDevice: msgDelete } = this.props;
    if (loadingDeleteDmxDevice === false && prevProps.loadingDeleteDmxDevice === true && msgDelete) {
      this.props.history.push('/dmxControllers');
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  onControllerChange(controllerId) {
    this.setState({ controllerId, universeId: '' });
    if (controllerId) {
      this.props.getDmxUniversesByController(this.state.user, controllerId);
    }
  }

  handleValidSubmit = (event, values) => {
    const user = this.state.user;
    values.id = this.state.device.id;
    values.controller_id = Number(values.controller_id);
    values.universe_id = Number(values.universe_id);
    values.start_channel = Number(values.start_channel);
    values.channel_count = Number(values.channel_count);
    values.profile_id = Number(values.profile_id);
    values.active = Number(this.state.device.active) === 1;
    values.token = user.token;
    this.props.updateDmxDevice(values);
  };

  doDelete() {
    const user = this.state.user;
    this.props.deleteDmxDevice({ id: this.state.device.id, token: user.token });
    this.setState({ showConfirmDelete: false });
  }

  render() {
    const { controllers, universes } = this.props;
    if (!controllers || !universes) return null;
    const lastChannel = Number(this.state.startChannel) + Number(this.state.channelCount) - 1;

    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Editar dispositivo DMX')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="deviceName">{this.props.t('Nombre')}</Label>
                  <AvField
                    value={this.state.device.name}
                    name="name"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="deviceName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="deviceType">{this.props.t('Tipo')}</Label>
                  <AvInput
                    value={this.state.deviceType}
                    name="device_type"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="deviceType"
                    onChange={(e) => this.setState({ deviceType: e.target.value, profileId: '' })}
                  >
                    <option value="LED">LED</option>
                    <option value="SPOTLIGHT">SPOTLIGHT</option>
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="deviceProfile">{this.props.t('Perfil')}</Label>
                  <AvInput
                    value={this.state.profileId}
                    name="profile_id"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="deviceProfile"
                    onChange={(e) => this.onProfileChange(e.target.value)}
                  >
                    <option value="">{this.props.t('Selecciona un perfil')}</option>
                    {(this.props.profiles || [])
                      .filter((p) => p.device_type === this.state.deviceType)
                      .map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.name} ({p.channel_count} canales)
                        </option>
                      ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="linkedEntityType">{this.props.t('Vinculado a')}</Label>
                  <AvInput
                    value={this.state.linkedEntityType}
                    name="linked_entity_type"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="linkedEntityType"
                    onChange={(e) => this.setState({ linkedEntityType: e.target.value })}
                  >
                    <option value="WORKSTATION_POSITION">WORKSTATION_POSITION</option>
                    <option value="WORKSTATION">WORKSTATION</option>
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="linkedEntityId">{this.props.t('Posición / Estación (ws_pos o workstation)')}</Label>
                  <AvField
                    value={this.state.linkedEntityId}
                    name="linked_entity_id"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="linkedEntityId"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="controllerId">{this.props.t('Controlador')}</Label>
                  <AvInput
                    value={this.state.controllerId}
                    name="controller_id"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="controllerId"
                    onChange={(e) => this.onControllerChange(e.target.value)}
                  >
                    {controllers.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name} ({c.ip})
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="universeId">{this.props.t('Universo')}</Label>
                  <AvInput
                    value={this.state.universeId}
                    name="universe_id"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="universeId"
                    onChange={(e) => this.setState({ universeId: e.target.value })}
                  >
                    {(universes || []).map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.universe_number} ({u.channel_count} canales)
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="startChannel">{this.props.t('Primer canal')}</Label>
                  <AvField
                    value={this.state.startChannel}
                    name="start_channel"
                    type="number"
                    className="form-control"
                    validate={{ required: { value: true }, min: { value: 1 } }}
                    id="startChannel"
                    onChange={(e) => this.setState({ startChannel: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="channelCount">{this.props.t('Cantidad de canales')}</Label>
                  <AvField
                    value={this.state.channelCount}
                    name="channel_count"
                    type="number"
                    className="form-control"
                    validate={{ required: { value: true }, min: { value: 1 } }}
                    id="channelCount"
                    onChange={(e) => this.setState({ channelCount: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col>
                <Label>
                  {this.props.t('Último canal')}: <b>{lastChannel}</b>
                </Label>
              </Col>
              <Col>
                <FormGroup>
                  <Button color="secondary" type="submit" className="buttonStatus mt-2">
                    {this.props.t('Guardar cambios')}
                  </Button>
                  <Button
                    color="danger"
                    type="button"
                    className="buttonStatus mt-2 ml-2"
                    onClick={() => this.setState({ showConfirmDelete: true })}
                  >
                    {this.props.t('Eliminar dispositivo')}
                  </Button>
                </FormGroup>
              </Col>
            </AvForm>

            {this.state.popup ? (
              <SweetAlert
                type={this.state.alertType === 'correct' ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
                title={this.state.pop_msg}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
            {this.state.showConfirmDelete ? (
              <SweetAlert
                showCancel
                title="¿Estás seguro?"
                cancelBtnBsStyle="danger"
                confirmBtnBsStyle="success"
                confirmBtnText={this.props.t('ok')}
                cancelBtnText={this.props.t('Cancel')}
                onConfirm={() => this.doDelete()}
                onCancel={() => this.setState({ showConfirmDelete: false })}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { controllers } = state.getDmxControllers;
  const { universes } = state.getDmxUniversesByController;
  const { profiles } = state.getDmxProfiles;
  const { updateDmxDeviceError, loadingUpdateDmxDevice, messageDmxDevice: msgUpdate } = state.updateDmxDevice;
  const { loadingDeleteDmxDevice, messageDmxDevice: msgDelete } = state.deleteDmxDevice;
  return {
    controllers,
    universes,
    profiles,
    updateDmxDeviceError,
    loadingUpdateDmxDevice,
    messageDmxDevice: msgUpdate || msgDelete,
    loadingDeleteDmxDevice,
  };
};

export default withRouter(
  connect(mapStateprops, { getDmxControllers, getDmxUniversesByController, getDmxProfiles, updateDmxDevice, deleteDmxDevice })(
    withNamespaces()(UpdateDmxDeviceForm),
  ),
);
